export default __webpack_public_path__ + "static/media/walk-close.ab127e93.svg";